import { ReactComponent as CurvedLineTypeIcon } from 'assets/icons/curved_line_type.svg';
import { ReactComponent as DashDotLineIcon } from 'assets/icons/dash_dot_line.svg';
import { ReactComponent as DashedLineIcon } from 'assets/icons/dashed_line.svg';
import { ReactComponent as DottedLineIcon } from 'assets/icons/dotted_line.svg';
import { ReactComponent as StartLineIcon } from 'assets/icons/line_end_line.svg';
import { ReactComponent as LineNoneIcon } from 'assets/icons/line_none.svg';
import { ReactComponent as StartArrowIcon } from 'assets/icons/line_start_arrow.svg';
import { ReactComponent as StartCircleIcon } from 'assets/icons/line_start_circle.svg';
import { ReactComponent as StartDiamondIcon } from 'assets/icons/line_start_diamond.svg';
import { ReactComponent as StartLineArrowIcon } from 'assets/icons/line_start_line_arrow.svg';
import { ReactComponent as StartLongIcon } from 'assets/icons/line_start_long.svg';
import { ReactComponent as StartOutlineTriangleIcon } from 'assets/icons/line_start_outline_basic.svg';
import { ReactComponent as StartOutlineCircleIcon } from 'assets/icons/line_start_outline_circle.svg';
import { ReactComponent as StartOutlineCircleDiamond } from 'assets/icons/line_start_outline_diamond.svg';
import { ReactComponent as StartSharpIcon } from 'assets/icons/line_start_sharp.svg';
import { ReactComponent as LongDashDotLineIcon } from 'assets/icons/long_dash_dot_line.svg';
import { ReactComponent as LongDashLineIcon } from 'assets/icons/long_dash_line.svg';
import { ReactComponent as SolidLineIcon } from 'assets/icons/solid_line.svg';
import { ReactComponent as SteppedLineTypeIcon } from 'assets/icons/stepped_line_type.svg';
import { ReactComponent as StraightLineTypeIcon } from 'assets/icons/straight_line_type.svg';
import { LineWidgetTypes } from 'widgets/Lines/LineWidget/LineWidget.types';

import { ArrowStyleTypes, LineWidgetDashArrayTypes } from '../CommonLine.types';

const LINE_MIN_WIDTH = 1;
const LINE_MAX_WIDTH = 20;

const LINE_TYPE_OPTIONS = [
  {
    value: LineWidgetTypes.straight,
    label: 'lineType.straight',
    icon: <StraightLineTypeIcon />,
  },
  {
    value: LineWidgetTypes.curved,
    label: 'lineType.curved',
    icon: <CurvedLineTypeIcon />,
  },
  {
    value: LineWidgetTypes.stepped,
    label: 'lineType.stepped',
    icon: <SteppedLineTypeIcon />,
  },
];

const ARROW_OPTIONS = [
  {
    value: ArrowStyleTypes.none,
    label: 'arrow.none',
    iconComponent: LineNoneIcon,
  },
  {
    value: ArrowStyleTypes.lineArrow,
    label: 'arrow.lineArrow',
    iconComponent: StartLineArrowIcon,
  },
  {
    value: ArrowStyleTypes.basic,
    label: 'arrow.triangle',
    iconComponent: StartArrowIcon,
  },
  {
    value: ArrowStyleTypes.outlineBasic,
    label: 'arrow.outlineTriangle',
    iconComponent: StartOutlineTriangleIcon,
  },
  {
    value: ArrowStyleTypes.sharp,
    label: 'arrow.sharp',
    iconComponent: StartSharpIcon,
  },
  {
    value: ArrowStyleTypes.long,
    label: 'arrow.long',
    iconComponent: StartLongIcon,
  },
  {
    value: ArrowStyleTypes.line,
    label: 'arrow.line',
    iconComponent: StartLineIcon,
  },
  {
    value: ArrowStyleTypes.circle,
    label: 'arrow.circle',
    iconComponent: StartCircleIcon,
  },
  {
    value: ArrowStyleTypes.outlineCircle,
    label: 'arrow.outlineCircle',
    iconComponent: StartOutlineCircleIcon,
  },
  {
    value: ArrowStyleTypes.diamond,
    label: 'arrow.diamond',
    iconComponent: StartDiamondIcon,
  },
  {
    value: ArrowStyleTypes.outlineDiamond,
    label: 'arrow.outlineDiamond',
    iconComponent: StartOutlineCircleDiamond,
  },
];

const LINE_STYLE_OPTIONS = [
  {
    value: LineWidgetDashArrayTypes.solid,
    label: 'lineStyle.solid',
    icon: <SolidLineIcon />,
  },
  {
    value: LineWidgetDashArrayTypes.dotted,
    label: 'lineStyle.dot',
    icon: <DottedLineIcon />,
  },
  {
    value: LineWidgetDashArrayTypes.dashed,
    label: 'lineStyle.dash',
    icon: <DashedLineIcon />,
  },
  {
    value: LineWidgetDashArrayTypes.longDash,
    label: 'lineStyle.longDash',
    icon: <LongDashLineIcon />,
  },
  {
    value: LineWidgetDashArrayTypes.dashDot,
    label: 'lineStyle.dashDot',
    icon: <DashDotLineIcon />,
  },
  {
    value: LineWidgetDashArrayTypes.longDashDot,
    label: 'lineStyle.longDashDot',
    icon: <LongDashDotLineIcon />,
  },
];

export { LINE_MIN_WIDTH, LINE_MAX_WIDTH, LINE_TYPE_OPTIONS, LINE_STYLE_OPTIONS, ARROW_OPTIONS };
